import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import ForgotPassword from "./ForgotPassword";
import Container from "@mui/material/Container";
import images from "../../global-styles/images";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton, InputAdornment, Typography } from "@mui/material";
const style = {
  position: "relative",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 470,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "17px",
  //   p: 4,
};

export default function ChangePasswordModal(props: any) {
  const { changePasswordModal, closeChangePassModal } = props;
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    closeChangePassModal(false);
  };
  const [isLoading, setIsloading] = React.useState(false);

  return (
    <Modal
      open={changePasswordModal}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      disableEnforceFocus={true}
    >
      <Box
        sx={style}
        className={
          isLoading
            ? "loader auth-form change-pass-form "
            : "change-pass-form auth-form"
        }
      >
        <Container component="div" className="form-container">
          <IconButton className="close-icon-changepass" onClick={handleClose}>
            <CloseIcon />
          </IconButton>
          <Box className="logo-wrap">
            <img src={images.logoBlack} alt="Cuvo Logo" />
          </Box>{" "}
          <Box className="logo-wrap">
            {/* <img src={images.logoBlack} alt="Cuvo Logo" /> */}
          </Box>
          <ForgotPassword
            type="change"
            changePasswordModal={changePasswordModal}
            handleClose={handleClose}
          />
        </Container>
      </Box>
    </Modal>
  );
}
